/**
 * This composable provides methods to register and unregister modals from the
 * global stack.
 *
 * It also helps to determine whcih modal has the "focus" and should have the
 * focus trap applied.
 */
export default function useModalStack() {
  const stack = useModalStackIds()

  /**
   * Register a modal to the stack.
   * @param id - The ID of the modal to register.
   */
  function register(id: string) {
    stack.value.unshift(id)
  }

  /**
   * Unregister a modal from the stack.
   * @param id - The ID of the modal to unregister.
   */
  function unregister(id: string) {
    stack.value = stack.value.filter((item) => item !== id)
  }

  /**
   * Check if a modal is the top modal in the stack.
   * @param id - The ID of the modal to check.
   * @returns True if the modal is the top modal, false otherwise.
   */
  function isTopModal(id: string) {
    return stack.value[0] === id
  }

  return {
    stack,
    register,
    unregister,
    isTopModal,
  }
}
